'use client';

import styled, { css } from 'styled-components';

import { CONTAINER_MAX } from '@/constants/breakpoints';
import { containerPaddingInline, flexCenterAligned } from '@/styles/common';

export const Header = styled.div<{
  $withBackButton: boolean;
  $isVisibleButton: boolean;
  $withCloseBtn: boolean;
}>`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ $withCloseBtn, $isVisibleButton }) =>
    $withCloseBtn || $isVisibleButton ? 'space-between' : 'flex-start'};
  padding: 40px 40px 20px;

  ${({ $isVisibleButton }) =>
    !$isVisibleButton &&
    css`
      @media (max-width: ${CONTAINER_MAX.mobileL}) {
        padding: 20px 20px 0;
      }
    `}

  ${({ $withBackButton }) =>
    !$withBackButton &&
    css`
      ${containerPaddingInline};
      padding-block: 20px !important;
    `}

  ${({ $isVisibleButton }) =>
    $isVisibleButton &&
    css`
      [data-id='header-logo'] {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    `}
`;

export const CrossButton = styled.button`
  ${flexCenterAligned};
  position: absolute;
  right: 28px;
  width: 44px;
  height: 44px;
  background: none;
  border: none;
  border-radius: 50%;
  color: var(--textAndLabels-tertiary);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: var(--bg-tertiary);
    color: var(--system-yellow);
  }

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    right: 6px;
  }
`;

export const BackButton = styled.button`
  all: unset;
  cursor: pointer;
`;
